import { SwitchControl } from '../../components/SwitchControl';

interface ModelPrivacyDefaultsProps {
  showIdentity: boolean;
  onShowIdentityChange: (value: boolean) => void;
}

export function ModelPrivacyDefaults({
  showIdentity,
  onShowIdentityChange,
}: ModelPrivacyDefaultsProps) {
  return (
    <div className="flex flex-col gap-4 pt-4 border-t border-line-soft mt-2">
      <div>
        <label className="label-mono">Privacy Defaults</label>
        <p className="text-[14px] text-text-dim mt-1">
          These settings apply to all events you model for. You can override them for individual events.
        </p>
      </div>

      {/* Show Identity Toggle */}
      <PrivacyToggle
        title="Show my identity on events"
        description="When enabled, your profile appears on event listings. When disabled, you'll appear as 'Model confirmed'."
        checked={showIdentity}
        onChange={onShowIdentityChange}
      />

    </div>
  );
}

interface PrivacyToggleProps {
  title: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

function PrivacyToggle({ title, description, checked, onChange }: PrivacyToggleProps) {
  return (
    <div className="flex items-start gap-4">
      <SwitchControl checked={checked} onChange={onChange} ariaLabel={title} />
      <div className="flex-1 min-w-0">
        <div className="text-[14px] font-medium text-text leading-tight">{title}</div>
        <p className="text-[13px] text-text-dim mt-1 leading-relaxed">{description}</p>
      </div>
    </div>
  );
}
